import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    fullPage: {
        position: 'absolute',
        width: '100vw',
        height: '100vh',
        zIndex: theme.zIndex.modal,
    },
}));
